import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Protocol } from "@msuite/utils/types";
import { ContactMemberCard, UserCard } from "@/components/cards";

/** Props Interface */
interface SendProtocolModalRecipientProps {
	involvement: Protocol["_involvements"][number];
}

export function SendProtocolModalRecipient({ involvement }: SendProtocolModalRecipientProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const email = involvement.user?.email ?? involvement.contactMember?.email ?? null;

	/** Render */
	return (
		<div className="justify-between items-center h-stack">
			{involvement.userId ? (
				<UserCard
					userId={involvement.userId}
					variant="plain"
				/>
			) : (
				<ContactMemberCard
					contactMemberId={involvement.contactMemberId ?? ""}
					variant="plain"
				/>
			)}
			{email ? (
				<p className="label">{email}</p>
			) : (
				<Tag
					variant="plain"
					color="amber"
				>
					{t("protocols.no_email_address")}
				</Tag>
			)}
		</div>
	);
}
